import React, { useEffect } from 'react';

export default function ErrorThrower({
  ...props
}) {
  useEffect(() => {
    // We return the result, which is a function to clean up the listen hook.
    throw new Error("I am a generic error.");
  }) 
  // Return an empty component if there are no errors.
  return (
    <div>
      You'll never see me!
    </div>
  )
}